export const ROUTE_PERMISSIONS = {
  /* ============================================================
   * SUPER ADMIN ONLY
   * ============================================================ */
  // '/organization':  ['super_admin'],
  '/onboarding':    ['super_admin'],
  '/billing':       ['super_admin'],
  '/pricing':       ['super_admin'],
  '/roles':         ['super_admin'],
  '/permissions':   ['super_admin'],
  '/features':      ['super_admin'],
  '/testimonials':  ['super_admin'],
  '/blogs':         ['super_admin'],
  '/plan-pricing':  ['super_admin'],
  '/regions':       ['super_admin'],
  '/stats':         ['super_admin'],

  /* ============================================================
   * SUPER ADMIN + ORG ADMIN
   * ============================================================ */
  '/organization':  ['super_admin', 'org_admin'],
  '/branches':      ['super_admin', 'org_admin'],
  '/shortcode':     ['super_admin', 'org_admin'],
  '/optout':        ['super_admin', 'org_admin'],
  '/sender-ids':    ['super_admin', 'org_admin'],
  '/sms-balance':   ['super_admin', 'org_admin'],
  '/settings':      ['super_admin', 'org_admin'],
  '/users':         ['super_admin', 'org_admin'],
  '/import':        ['super_admin', 'org_admin'],

  /* ============================================================
   * STAFF AND ABOVE
   * ============================================================ */
  '/drips':         ['super_admin', 'org_admin', 'staff'],
  '/visitors':      ['super_admin', 'org_admin', 'staff'],
  '/giving':        ['super_admin', 'org_admin', 'staff'],
  '/chatbot':       ['super_admin', 'org_admin', 'staff'],
  '/health':        ['super_admin', 'org_admin', 'staff'],

  /* ============================================================
   * EVERYONE (ANY ROLE)
   * ============================================================ */
  '/dashboard':     ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/members':       ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/broadcast':     ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/automation':    ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/birthdays':     ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/polls':         ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/inbox':         ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/attendance':    ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/events':        ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/prayers':       ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/devotionals':   ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/groups':        ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/templates':     ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/msglog':        ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/analytics':     ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/notifications': ['super_admin', 'org_admin', 'staff', 'viewer'],
  '/profile':       ['super_admin', 'org_admin', 'staff', 'viewer'],
};

export const getRolesForPath = (pathname) => {
  if (!pathname) return null;

  const clean = pathname.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';

  if (ROUTE_PERMISSIONS[clean]) return ROUTE_PERMISSIONS[clean];

  const segments = clean.split('/').filter(Boolean);
  while (segments.length > 1) {
    segments.pop();
    const parent = '/' + segments.join('/');
    if (ROUTE_PERMISSIONS[parent]) return ROUTE_PERMISSIONS[parent];
  }

  return null;
};